import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function Footer(props) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const listKey = process.env.REACT_APP_LIST_KEY;
  const api_url = process.env.REACT_APP_API_URL;

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setEmail(inputValue);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    setMessage("");

    // Updated to point directly to the new API endpoint
    const url = "https://admin-api-dev.nxa.tel/create-news-letter-zoho-api";

    // The new API expects an object with "Email" and "Name"
    const data = {
      Email: email,
      Name: email, // using the email value as Name so that the payload always includes both fields
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.ok) {
        setMessage("Successfully subscribed!");
        setEmail(""); // Clear the input field
      } else {
        setMessage(`Error: ${result.message || "Subscription failed."}`);
        setEmail(""); // Clear the input field
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
      setEmail(""); // Clear the input field
    } finally {
      setLoading(false);
      setEmail(""); // Clear the input field
      setMessage("");
    }
  };

  return (
    <div className="homepage">
      <footer className="footer-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-2">
                  <div className="footer-nav">
                    <ul className="">
                      {/* Sales  */}
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                      >
                        Sales
                      </div>
                      <li className="list-style-none pt--2 pb--2">
                        <Link
                          to="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Contact Sales
                        </Link>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <Link
                          to="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          +27 87 910 3000
                        </Link>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <Link
                          to="/pricing"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Plan & Pricing
                        </Link>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <Link
                          to="/demo"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Request a Demo
                        </Link>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <Link
                          to="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Webinars and Events
                        </Link>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <Link
                          to="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Partner Program
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Solution */}
                <div className="col-md-2">
                  <div className="footer-nav">
                    <ul className="">
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                      >
                        Solution
                      </div>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="/start-smart"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Start Smart
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Cloud Phone
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          {" "}
                          Ms Teams SIP
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Trunk
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          SMS Messaging
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          IVR (Call Menu)
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Whatsapp
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="https://api.whatsapp.com/send/?phone=27672607763&text&type=phone_number&app_absent=0"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Business
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="footer-nav">
                    <ul className="">
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                      >
                        Product
                      </div>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="/calls"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Phone
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="/meetings"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Meeting
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="/message"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Message
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="/business-cloud"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Cloud Storage
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Devices
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Business Pre-Paid Internet
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Virtual Numbers
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="footer-nav">
                    <ul className="">
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                      >
                        Company
                      </div>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="/about-us"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          About Us
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="/Blog"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Blog
                        </a>
                      </li>
                      {/* <li className="list-style-none pt--2 pb--2">
                        <a
                          href="/why-nxatel"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Why Nxatel
                        </a>
                      </li> */}
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          {" "}
                          Support-0861NXATEL
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="#"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Contact us
                        </a>
                      </li>
                      <li className="list-style-none pt--2 pb--2">
                        <a
                          href="https://careers.nxa.tel/jobs/Careers"
                          className="text--black font--14 pt--7 pb--7 sf--t-regular hover-text--orange c--pointer text--decoration-none fw--500"
                        >
                          Join us
                          <span
                            style={{
                              background: "#8ecd46",
                              borderRadius: "3px",
                              padding: "2px 6px",
                              fontSize: "10px",
                              marginLeft: "6px", // Adds space between text and span
                              color: "#000",
                              fontFamily: "sf_ui_textmedium",
                              fontWeight: "600",
                              whiteSpace: "nowrap", // Prevents wrapping
                              display: "inline-block",
                            }}
                          >
                            We Hiring
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="pl--20 about-nexa-footer">
                    <a className="footer-logo">
                      <img
                        src="./../assets/images/homepagelogo.png"
                        alt="logo"
                        className="w--120 mb--10"
                      />
                    </a>
                    <div className="text--gray-4757 lh--23 mb--10 font--14 dm--sans ">
                      Nxatel, Pty Ltd. is a Modern unified communication
                      platform, for Small and Medium businesses, It’s easy to
                      set-up you just need 3 minutes and you gain access to
                      cloud phone system, virtual meetings, chats, SMS’s and
                      cloud storage solutions all in single App.
                    </div>
                    <div className="mt--24 mb--8 font--20 text--blue-1d3f dm--sans fw--700">
                      Be in the know
                    </div>
                    <form
                      onSubmit={handleSubmit}
                      className="d-flex align-items-center gap--10"
                    >
                      <input
                        className="footer-input"
                        placeholder="Email"
                        type="text"
                        value={email}
                        onChange={handleInputChange}
                        required
                      />
                      <button
                        type="submit"
                        className="nav-link sf--t-reguler text--white font--14 p--10 radius--50 bg--orange w--min-110"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Sign Up Now"}
                      </button>
                    </form>
                    {message && <p className="text--red">{message}</p>}
                  </div>
                </div>
              </div>
              <div className="row pt--24 gap--sm-10 ">
                <div className="col-md-4 d-flex align-self-center justify-content--sm-center">
                  <div className="font--16 text--black dm--sans fw-700">
                    Copyright@Nxatel.2020
                  </div>
                </div>
                <div className="col-md-4 d-flex align-self-center justify-content--sm-center">
                  <ul className="nav ">
                    <li>
                      <a
                        href="https://support.nxa.tel/portal/"
                        className="font--16 dm--sans pr--12 pl--12 text--black hover-text--orange  fw-700"
                      >
                        Support
                      </a>
                    </li>
                    <li>
                      <a
                        href="/privacy"
                        className="font--16 dm--sans pr--12 pl--12 text--black hover-text--orange  fw-700"
                      >
                        Privacy
                      </a>
                    </li>
                    <li>
                      <a
                        href="/terms"
                        className="font--16 dm--sans pr--12 pl--12 text--black hover-text--orange  fw-700"
                      >
                        Terms
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 d-flex align-self-center justify-content--sm-center">
                  <ul className=" nav pl--20">
                    <li>
                      <Link
                        to="//www.facebook.com/Nxatel/"
                        target={"_blank"}
                        className="font--16 fw--700 border--1 border--black mr--5 ml--5 radius--50 w--45 h--45 lh--35 d-flex align-items-center justify-content-center text--black dm--sans hover-text--orange"
                      >
                        fb.
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="//www.instagram.com/nxatel/?hl=en"
                        target={"_blank"}
                        className="font--16 fw--700 border--1 border--black mr--5 ml--5 radius--50 w--45 h--45 lh--35 d-flex align-items-center justify-content-center text--black dm--sans hover-text--orange"
                      >
                        ig.
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="//twitter.com/nxatel_"
                        target={"_blank"}
                        className="font--16 fw--700 border--1 border--black mr--5 ml--5 radius--50 w--45 h--45 lh--35 d-flex align-items-center justify-content-center text--black dm--sans  hover-text--orange"
                      >
                        tw.
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="//www.youtube.com/channel/UCgUIl2_YkGxiipc2M_-GE5A"
                        target={"_blank"}
                        className="font--16 fw--700 border--1 border--black mr--5 ml--5 radius--50 w--45 h--45 lh--35 d-flex align-items-center justify-content-center text--black dm--sans hover-text--orange"
                      >
                        yt.
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
